<template>
  <section
    v-if="exam.is_in_grace_period"
    class="container is-full is-greyish align-vertical is-centered pb-5"
  >
    <h1 class="title huge-title mt-1 opacity-6">
      <i class="fa fa-clock-o fa-3x" />
    </h1>
    <h1
      class="text-is-blue huge-title"
      v-html="$t('exam.please-wait-for-next-attempt')"
    />
    <div class="subtitle is-4">
      <p
        v-html="
          $t('exam.in-the-meantime-revise-chapters', {
            url: '/course/'+exam.course_id,
          })
        "
      />
      <p
        v-html="
          $t('exam.next-attempt-wait-text', {
            time_left: exam.previousAttempt.time_till_next_attempt,
          })
        "
      />
      <p
        v-html="
          $t('exam.last-attempt-results', {
            results: exam.previousAttempt.result,
            pass_rate: exam.pass_rate,
          })
        "
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'GracePeriod',

  props: {
    exam: { type: Object, required: true }
  }
};
</script>
